export interface CountryOption {
    code: string;    // phone code with plus sign, e.g. "+1"
    label: string;   // country name, e.g. "United States"
    iso: string;     // ISO alpha-2 code, e.g. "US"
  }
  
  export const countryCodes: CountryOption[] = [
    { code: "+1", label: "United States", iso: "US" },
    { code: "+1", label: "Canada", iso: "CA" },
    { code: "+93", label: "Afghanistan", iso: "AF" },
    { code: "+355", label: "Albania", iso: "AL" },
    { code: "+213", label: "Algeria", iso: "DZ" },
    { code: "+376", label: "Andorra", iso: "AD" },
    { code: "+244", label: "Angola", iso: "AO" },
    { code: "+1", label: "Anguilla", iso: "AI" },
    { code: "+672", label: "Antarctica", iso: "AQ" },
    { code: "+1", label: "Antigua and Barbuda", iso: "AG" },
    { code: "+54", label: "Argentina", iso: "AR" },
    { code: "+374", label: "Armenia", iso: "AM" },
    { code: "+297", label: "Aruba", iso: "AW" },
    { code: "+61", label: "Australia", iso: "AU" },
    { code: "+43", label: "Austria", iso: "AT" },
    { code: "+994", label: "Azerbaijan", iso: "AZ" },
    { code: "+1", label: "Bahamas", iso: "BS" },
    { code: "+973", label: "Bahrain", iso: "BH" },
    { code: "+880", label: "Bangladesh", iso: "BD" },
    { code: "+1", label: "Barbados", iso: "BB" },
    { code: "+375", label: "Belarus", iso: "BY" },
    { code: "+32", label: "Belgium", iso: "BE" },
    { code: "+501", label: "Belize", iso: "BZ" },
    { code: "+229", label: "Benin", iso: "BJ" },
    { code: "+1", label: "Bermuda", iso: "BM" },
    { code: "+975", label: "Bhutan", iso: "BT" },
    { code: "+591", label: "Bolivia", iso: "BO" },
    { code: "+387", label: "Bosnia and Herzegovina", iso: "BA" },
    { code: "+267", label: "Botswana", iso: "BW" },
    { code: "+55", label: "Brazil", iso: "BR" },
    { code: "+246", label: "British Indian Ocean Territory", iso: "IO" },
    { code: "+1", label: "British Virgin Islands", iso: "VG" },
    { code: "+673", label: "Brunei", iso: "BN" },
    { code: "+359", label: "Bulgaria", iso: "BG" },
    { code: "+226", label: "Burkina Faso", iso: "BF" },
    { code: "+257", label: "Burundi", iso: "BI" },
    { code: "+855", label: "Cambodia", iso: "KH" },
    { code: "+237", label: "Cameroon", iso: "CM" },
    { code: "+1", label: "Cayman Islands", iso: "KY" },
    { code: "+236", label: "Central African Republic", iso: "CF" },
    { code: "+235", label: "Chad", iso: "TD" },
    { code: "+56", label: "Chile", iso: "CL" },
    { code: "+86", label: "China", iso: "CN" },
    { code: "+61", label: "Christmas Island", iso: "CX" },
    { code: "+61", label: "Cocos (Keeling) Islands", iso: "CC" },
    { code: "+57", label: "Colombia", iso: "CO" },
    { code: "+269", label: "Comoros", iso: "KM" },
    { code: "+243", label: "Congo (DRC)", iso: "CD" },
    { code: "+242", label: "Congo (Republic)", iso: "CG" },
    { code: "+682", label: "Cook Islands", iso: "CK" },
    { code: "+506", label: "Costa Rica", iso: "CR" },
    { code: "+225", label: "Côte d’Ivoire", iso: "CI" },
    { code: "+385", label: "Croatia", iso: "HR" },
    { code: "+53", label: "Cuba", iso: "CU" },
    { code: "+599", label: "Curaçao", iso: "CW" },
    { code: "+357", label: "Cyprus", iso: "CY" },
    { code: "+420", label: "Czech Republic", iso: "CZ" },
    { code: "+45", label: "Denmark", iso: "DK" },
    { code: "+253", label: "Djibouti", iso: "DJ" },
    { code: "+1", label: "Dominica", iso: "DM" },
    { code: "+1", label: "Dominican Republic", iso: "DO" },
    { code: "+593", label: "Ecuador", iso: "EC" },
    { code: "+20", label: "Egypt", iso: "EG" },
    { code: "+503", label: "El Salvador", iso: "SV" },
    { code: "+240", label: "Equatorial Guinea", iso: "GQ" },
    { code: "+291", label: "Eritrea", iso: "ER" },
    { code: "+372", label: "Estonia", iso: "EE" },
    { code: "+251", label: "Ethiopia", iso: "ET" },
    { code: "+500", label: "Falkland Islands", iso: "FK" },
    { code: "+298", label: "Faroe Islands", iso: "FO" },
    { code: "+679", label: "Fiji", iso: "FJ" },
    { code: "+358", label: "Finland", iso: "FI" },
    { code: "+33", label: "France", iso: "FR" },
    { code: "+594", label: "French Guiana", iso: "GF" },
    { code: "+689", label: "French Polynesia", iso: "PF" },
    { code: "+241", label: "Gabon", iso: "GA" },
    { code: "+220", label: "Gambia", iso: "GM" },
    { code: "+995", label: "Georgia", iso: "GE" },
    { code: "+49", label: "Germany", iso: "DE" },
    { code: "+233", label: "Ghana", iso: "GH" },
    { code: "+350", label: "Gibraltar", iso: "GI" },
    { code: "+30", label: "Greece", iso: "GR" },
    { code: "+299", label: "Greenland", iso: "GL" },
    { code: "+1", label: "Grenada", iso: "GD" },
    { code: "+590", label: "Guadeloupe", iso: "GP" },
    { code: "+1", label: "Guam", iso: "GU" },
    { code: "+502", label: "Guatemala", iso: "GT" },
    { code: "+44", label: "Guernsey", iso: "GG" },
    { code: "+224", label: "Guinea", iso: "GN" },
    { code: "+245", label: "Guinea-Bissau", iso: "GW" },
    { code: "+592", label: "Guyana", iso: "GY" },
    { code: "+509", label: "Haiti", iso: "HT" },
    { code: "+504", label: "Honduras", iso: "HN" },
    { code: "+36", label: "Hungary", iso: "HU" },
    { code: "+354", label: "Iceland", iso: "IS" },
    { code: "+91", label: "India", iso: "IN" },
    { code: "+62", label: "Indonesia", iso: "ID" },
    { code: "+98", label: "Iran", iso: "IR" },
    { code: "+964", label: "Iraq", iso: "IQ" },
    { code: "+353", label: "Ireland", iso: "IE" },
    { code: "+44", label: "Isle of Man", iso: "IM" },
    { code: "+972", label: "Israel", iso: "IL" },
    { code: "+39", label: "Italy", iso: "IT" },
    { code: "+1", label: "Jamaica", iso: "JM" },
    { code: "+81", label: "Japan", iso: "JP" },
    { code: "+44", label: "Jersey", iso: "JE" },
    { code: "+962", label: "Jordan", iso: "JO" },
    { code: "+7", label: "Kazakhstan", iso: "KZ" },
    { code: "+254", label: "Kenya", iso: "KE" },
    { code: "+686", label: "Kiribati", iso: "KI" },
    { code: "+965", label: "Kuwait", iso: "KW" },
    { code: "+996", label: "Kyrgyzstan", iso: "KG" },
    { code: "+856", label: "Laos", iso: "LA" },
    { code: "+371", label: "Latvia", iso: "LV" },
    { code: "+961", label: "Lebanon", iso: "LB" },
    { code: "+266", label: "Lesotho", iso: "LS" },
    { code: "+231", label: "Liberia", iso: "LR" },
    { code: "+218", label: "Libya", iso: "LY" },
    { code: "+423", label: "Liechtenstein", iso: "LI" },
    { code: "+370", label: "Lithuania", iso: "LT" },
    { code: "+352", label: "Luxembourg", iso: "LU" },
    { code: "+853", label: "Macau", iso: "MO" },
    { code: "+389", label: "North Macedonia", iso: "MK" },
    { code: "+261", label: "Madagascar", iso: "MG" },
    { code: "+265", label: "Malawi", iso: "MW" },
    { code: "+60", label: "Malaysia", iso: "MY" },
    { code: "+960", label: "Maldives", iso: "MV" },
    { code: "+223", label: "Mali", iso: "ML" },
    { code: "+356", label: "Malta", iso: "MT" },
    { code: "+692", label: "Marshall Islands", iso: "MH" },
    { code: "+596", label: "Martinique", iso: "MQ" },
    { code: "+222", label: "Mauritania", iso: "MR" },
    { code: "+230", label: "Mauritius", iso: "MU" },
    { code: "+262", label: "Mayotte", iso: "YT" },
    { code: "+52", label: "Mexico", iso: "MX" },
    { code: "+691", label: "Micronesia", iso: "FM" },
    { code: "+373", label: "Moldova", iso: "MD" },
    { code: "+377", label: "Monaco", iso: "MC" },
    { code: "+976", label: "Mongolia", iso: "MN" },
    { code: "+382", label: "Montenegro", iso: "ME" },
    { code: "+1", label: "Montserrat", iso: "MS" },
    { code: "+212", label: "Morocco", iso: "MA" },
    { code: "+258", label: "Mozambique", iso: "MZ" },
    { code: "+95", label: "Myanmar (Burma)", iso: "MM" },
    { code: "+264", label: "Namibia", iso: "NA" },
    { code: "+674", label: "Nauru", iso: "NR" },
    { code: "+977", label: "Nepal", iso: "NP" },
    { code: "+31", label: "Netherlands", iso: "NL" },
    { code: "+687", label: "New Caledonia", iso: "NC" },
    { code: "+64", label: "New Zealand", iso: "NZ" },
    { code: "+505", label: "Nicaragua", iso: "NI" },
    { code: "+227", label: "Niger", iso: "NE" },
    { code: "+234", label: "Nigeria", iso: "NG" },
    { code: "+683", label: "Niue", iso: "NU" },
    { code: "+672", label: "Norfolk Island", iso: "NF" },
    { code: "+1", label: "Northern Mariana Islands", iso: "MP" },
    { code: "+47", label: "Norway", iso: "NO" },
    { code: "+968", label: "Oman", iso: "OM" },
    { code: "+92", label: "Pakistan", iso: "PK" },
    { code: "+680", label: "Palau", iso: "PW" },
    { code: "+970", label: "Palestine", iso: "PS" },
    { code: "+507", label: "Panama", iso: "PA" },
    { code: "+675", label: "Papua New Guinea", iso: "PG" },
    { code: "+595", label: "Paraguay", iso: "PY" },
    { code: "+51", label: "Peru", iso: "PE" },
    { code: "+63", label: "Philippines", iso: "PH" },
    { code: "+48", label: "Poland", iso: "PL" },
    { code: "+351", label: "Portugal", iso: "PT" },
    { code: "+1", label: "Puerto Rico", iso: "PR" },
    { code: "+974", label: "Qatar", iso: "QA" },
    { code: "+262", label: "Réunion", iso: "RE" },
    { code: "+40", label: "Romania", iso: "RO" },
    { code: "+7", label: "Russia", iso: "RU" },
    { code: "+250", label: "Rwanda", iso: "RW" },
    { code: "+590", label: "Saint Barthélemy", iso: "BL" },
    { code: "+1", label: "Saint Kitts and Nevis", iso: "KN" },
    { code: "+1", label: "Saint Lucia", iso: "LC" },
    { code: "+590", label: "Saint Martin", iso: "MF" },
    { code: "+508", label: "Saint Pierre and Miquelon", iso: "PM" },
    { code: "+1", label: "Saint Vincent and the Grenadines", iso: "VC" },
    { code: "+685", label: "Samoa", iso: "WS" },
    { code: "+378", label: "San Marino", iso: "SM" },
    { code: "+239", label: "São Tomé and Príncipe", iso: "ST" },
    { code: "+966", label: "Saudi Arabia", iso: "SA" },
    { code: "+221", label: "Senegal", iso: "SN" },
    { code: "+381", label: "Serbia", iso: "RS" },
    { code: "+248", label: "Seychelles", iso: "SC" },
    { code: "+232", label: "Sierra Leone", iso: "SL" },
    { code: "+65", label: "Singapore", iso: "SG" },
    { code: "+1", label: "Sint Maarten", iso: "SX" },
    { code: "+421", label: "Slovakia", iso: "SK" },
    { code: "+386", label: "Slovenia", iso: "SI" },
    { code: "+677", label: "Solomon Islands", iso: "SB" },
    { code: "+252", label: "Somalia", iso: "SO" },
    { code: "+27", label: "South Africa", iso: "ZA" },
    { code: "+82", label: "South Korea", iso: "KR" },
    { code: "+211", label: "South Sudan", iso: "SS" },
    { code: "+34", label: "Spain", iso: "ES" },
    { code: "+94", label: "Sri Lanka", iso: "LK" },
    { code: "+249", label: "Sudan", iso: "SD" },
    { code: "+597", label: "Suriname", iso: "SR" },
    { code: "+47", label: "Svalbard and Jan Mayen", iso: "SJ" },
    { code: "+268", label: "Swaziland", iso: "SZ" },
    { code: "+46", label: "Sweden", iso: "SE" },
    { code: "+41", label: "Switzerland", iso: "CH" },
    { code: "+963", label: "Syria", iso: "SY" },
    { code: "+886", label: "Taiwan", iso: "TW" },
    { code: "+992", label: "Tajikistan", iso: "TJ" },
    { code: "+255", label: "Tanzania", iso: "TZ" },
    { code: "+66", label: "Thailand", iso: "TH" },
    { code: "+670", label: "Timor-Leste", iso: "TL" },
    { code: "+228", label: "Togo", iso: "TG" },
    { code: "+690", label: "Tokelau", iso: "TK" },
    { code: "+676", label: "Tonga", iso: "TO" },
    { code: "+1", label: "Trinidad and Tobago", iso: "TT" },
    { code: "+216", label: "Tunisia", iso: "TN" },
    { code: "+90", label: "Turkey", iso: "TR" },
    { code: "+993", label: "Turkmenistan", iso: "TM" },
    { code: "+1", label: "Turks and Caicos Islands", iso: "TC" },
    { code: "+688", label: "Tuvalu", iso: "TV" },
    { code: "+1", label: "U.S. Virgin Islands", iso: "VI" },
    { code: "+256", label: "Uganda", iso: "UG" },
    { code: "+380", label: "Ukraine", iso: "UA" },
    { code: "+971", label: "United Arab Emirates", iso: "AE" },
    { code: "+44", label: "United Kingdom", iso: "GB" },
    { code: "+598", label: "Uruguay", iso: "UY" },
    { code: "+998", label: "Uzbekistan", iso: "UZ" },
    { code: "+678", label: "Vanuatu", iso: "VU" },
    { code: "+39", label: "Vatican City", iso: "VA" },
    { code: "+58", label: "Venezuela", iso: "VE" },
    { code: "+84", label: "Vietnam", iso: "VN" },
    { code: "+681", label: "Wallis and Futuna", iso: "WF" },
    { code: "+212", label: "Western Sahara", iso: "EH" },
    { code: "+967", label: "Yemen", iso: "YE" },
    { code: "+260", label: "Zambia", iso: "ZM" },
    { code: "+263", label: "Zimbabwe", iso: "ZW" },
    ];
  